import * as colors from "../styles/colors";
import isCardinalActive from "./isCardinalActive";
import * as constants from "../constants";

export const geoJsonFormat = (latitude, longitude, propertyId) => ({
  id: propertyId,
  type: "Feature",
  geometry: {
    type: "Point",
    coordinates: [longitude, latitude],
  },
});

export const getTotalPoints = (clusters) => {
  let points = 0;

  for (const cluster of clusters) {
    if (cluster.properties) {
      points = points + cluster.properties.point_count;
    } else {
      points = points + 1;
    }
  }

  return points;
};

export const getAllLeaves = (clusters, supercluster, callback) => {
  for (const cluster of clusters) {
    try {
      if (cluster.properties) {
        const leaves = supercluster.getLeaves(
          cluster.properties.cluster_id,
          "Infinity"
        );
        for (const leaf of leaves) {
          callback(leaf.id);
        }
      } else {
        callback(cluster.id);
      }
    } catch (e) {
      continue;
    }
  }
};

export const isFilteredProperty = ({ property, filter }) => {
  if (property.isDeleted) {
    return false;
  }

  if (filter.other === "VIP" && !isCardinalActive(property.cardinal)) {
    return false;
  } else if (
    filter.other === "PATROL" &&
    !(property.patrolWindows.length > 0)
  ) {
    return false;
  }

  let passedColorFilter = false;
  let passedVariantFilter = false;
  const filterColors = [];
  const filterVariants = [];
  if (filter.noService) filterColors.push(colors.markers.property.NO_SERVICE);
  if (filter.lowPriority)
    filterColors.push(colors.markers.property.LOW_PRIORITY);
  if (filter.mediumPriority)
    filterColors.push(colors.markers.property.MEDIUM_PRIORITY);
  if (filter.highPriority)
    filterColors.push(colors.markers.property.HIGH_PRIORITY);
  if (filterColors.includes(property.markerParams.color))
    passedColorFilter = true;

  if (filter.noVariant) filterVariants.push(null);
  if (filter.resVariant) filterVariants.push("RESIDENTIAL");
  if (filter.comVariant) filterVariants.push("COMMERCIAL");
  if (filter.technologiesVariant)
    filterVariants.push(constants.property.variant.TECHNOLOGIES.value);
  if (filterVariants.includes(property.variant)) passedVariantFilter = true;

  if (!passedColorFilter || !passedVariantFilter) {
    return false;
  } else {
    return true;
  }
};

export const isLocationInBounds = (location, bounds) => {
  try {
    if (
      location.latitude > bounds.ne.lat ||
      location.longitude > bounds.ne.lng ||
      location.latitude < bounds.sw.lat ||
      location.longitude < bounds.sw.lng
    )
      return false;
    else return true;
  } catch (e) {
    // do nothing
  }
};
